export default __webpack_public_path__ + "static/media/bounding.d02f04df.png";